import React from 'react'

// Legacy callback route. The current connection uses public/microsoft-callback.html.
// Leave the response intact so an opening MSAL 4 window can finish authentication.
export default function CalendarAuthCallback() {
  return <main style={{ padding: 32 }}>
    <h2>Connecting Outlook</h2>
    <p>Complete sign-in in the SPCC window that opened this page.</p>
  </main>
}
